import { defineStore } from 'pinia'
import httpService from '@/core/services/httpService'

export const useMediaStore = defineStore('media', {
  state: () => ({
    images: [],
    selectedImages: [],
    selectedFiles: []
  }),
  actions: {
    async fetchImages() {
      try {
        const response = await httpService.get('/api/v1/media/images/')
        if (response.body && Array.isArray(response.body)) {
          this.images = response.body
        } else {
          this.images = []
        }
      } catch {}
    },
    async fetchSelectedImages() {
      try {
        const response = await httpService.get('/api/v1/media/images/selected_images/')
        if (response.body && Array.isArray(response.body)) {
          this.selectedImages = response.body
        } else {
          this.selectedImages = []
        }
      } catch {}
    },
    toggleSelect(imageId) {
      const idx = this.selectedImages.map(i => i.id).indexOf(imageId)
      if (idx >= 0) {
        this.selectedImages.splice(idx, 1)
        return
      }
      if (this.selectedImages.length >= 5) {
        alert('Maximum of 5 images can be selected.')
        return
      }
      const img = this.images.find(i => i.id === imageId)
      if (img) {
        this.selectedImages.push(img)
      }
    },
    isSelected(imageId) {
      return this.selectedImages.some(i => i.id === imageId)
    },
    async deleteImage(imageId) {
      const confirmDelete = confirm('Are you sure you want to delete this image?')
      if (!confirmDelete) return
      try {
        await httpService.delete(`/api/v1/media/images/${imageId}/`)
        this.images = this.images.filter(img => img.id !== imageId)
        this.selectedImages = this.selectedImages.filter(img => img.id !== imageId)
      } catch {}
    },
    async applyChanges() {
      try {
        const payload = {
          selected_images: this.selectedImages.map(i => i.id)
        }
        await httpService.post('/api/v1/media/images/update-selected/', payload)
        alert('Changes applied successfully!')
      } catch {}
    },
    async resetSelected() {
      try {
        this.selectedImages = []
        await httpService.post('/api/v1/media/images/update-selected/', {
          selected_images: []
        })
        alert('Selected images cleared!')
      } catch {}
    },
    handleFileUpload(event) {
      this.selectedFiles = [...event.target.files]
    },
    async uploadImages() {
      if (!this.selectedFiles.length) {
        alert('Please select file(s) before uploading.')
        return
      }
      const formData = new FormData()
      for (const file of this.selectedFiles) {
        formData.append('image', file)
      }
      try {
        const response = await httpService.post('api/v1/media/images/', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        if (response?.response?.status === 201) {
          alert('Image(s) uploaded successfully!')
          this.selectedFiles = []
          if (this.$refs?.fileInput) {
            this.$refs.fileInput.value = ''
          }
          await this.fetchImages()
        } else {
          alert('Image upload failed!')
        }
      } catch {}
    }
  }
})
